import { StyleSheet, View } from "react-native";
import { Link } from "expo-router";
import { Colors } from "colors";
import { fp, spH, spV } from "utils/normalizeV2";
import VText from "components/VText";
import ParentScrollView from "components/ParentScrollView";
import Heading from "components/Heading";
import { Helmet } from "react-helmet";


export default function NotFound() {
    return (
        <ParentScrollView>
            <Helmet>
                <title>404 - Page Not Found</title>
                <meta name="description" content="The page you are looking for doesn't exist or has been moved." />
                <meta name="robots" content="noindex, nofollow" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="author" content="Vetir" />
                <meta name="keywords" content="404, Page Not Found, Vetir" />

                
                
            </Helmet>
            <View style={styles.container}>
                <View style={styles.content}>
                    <Heading type="h1" style={styles.title}>
                        404
                    </Heading>
                    <Heading type="h2" style={styles.subtitle}>
                        Page Not Found
                    </Heading>
                    <VText style={styles.description}>
                        The page you are looking for doesn't exist or has been moved.
                    </VText>
                    <Link href={`/`} style={styles.button}>
                        <VText style={styles.buttonText}>Go to Homepage</VText>
                    </Link>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        padding: spH(20),
    },
    content: {
        alignItems: "center",
        justifyContent: "center",
    },
    title: {
        fontSize: fp(72),
        fontFamily: "LibreBodoni",
        fontWeight: "700",
        color: Colors.black,
        marginBottom: spV(16),
    },
    subtitle: {
        fontSize: fp(24),
        fontFamily: "JosefinSans",
        fontWeight: "600",
        color: Colors.black,
        marginBottom: spV(16),
    },
    description: {
        fontSize: fp(16),
        fontFamily: "JosefinSans",
        fontWeight: "400",
        color: Colors.black,
        textAlign: "center",
        marginBottom: spV(32),
        maxWidth: spH(400),
    },
    button: {
        backgroundColor: Colors.black,
        paddingHorizontal: spH(32),
        paddingVertical: spV(16),
        borderRadius: 4,
    },
    buttonText: {
        color: Colors.white,
        fontSize: fp(16),
        fontFamily: "JosefinSans",
        fontWeight: "600",
    },
});